function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("line", {
  x1: 50.69,
  y1: 32,
  x2: 56.32,
  y2: 32
});

var _ref2 =
/*#__PURE__*/
React.createElement("line", {
  x1: 7.68,
  y1: 32,
  x2: 38.69,
  y2: 32
});

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  x1: 26.54,
  y1: 15.97,
  x2: 56.32,
  y2: 15.97
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  x1: 7.68,
  y1: 15.97,
  x2: 14.56,
  y2: 15.97
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  x1: 35,
  y1: 48.03,
  x2: 56.32,
  y2: 48.03
});

var _ref6 =
/*#__PURE__*/
React.createElement("line", {
  x1: 7.68,
  y1: 48.03,
  x2: 23,
  y2: 48.03
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20.55,
  cy: 15.66,
  r: 6
});

var _ref8 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 44.69,
  cy: 32,
  r: 6
});

var _ref9 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 29,
  cy: 48.03,
  r: 6
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 64 64",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default __webpack_public_path__ + "static/media/filter.8cad698f.svg";
export { SvgComponent as ReactComponent };